<nb-card [nbSpinner]="getReportInputLoading">
  <nb-card-header>
    <div class="d-flex  align-items-center">
      <button routerLink="/dashboard/report/general" nbButton ghost status="basic"><i class="fal fa-arrow-right"></i>
      </button>
      <span>فیلترهای گزارش {{ report?.name }}</span>
    </div>
  </nb-card-header>
  <nb-card-body>
    <div class="row">
      <ng-container *ngFor="let filter of reportFilters">
        <ng-container [ngTemplateOutlet]="InputFilter"
                      [ngTemplateOutletContext]="{filter,selectedReportFilter:reportFilter}"></ng-container>
      </ng-container>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <div *ngIf="report" class="d-flex  justify-content-end gap-2 w-100">
      <nb-button-group>
        <button nbButtonToggle *ngIf="report.supportedOutputs.includes('table')" (click)="reportOutputType = 'table'" [pressed]="reportOutputType === 'table'">جدول
        </button>
        <button *ngIf="report.supportedOutputs.includes('chart')" [pressed]="reportOutputType === 'chart'"
                (click)="reportOutputType = 'chart'" nbButtonToggle>نمودار
        </button>
        <button *ngIf="report.supportedOutputs.includes('excel')" [pressed]="reportOutputType === 'excel'"
                (click)="reportOutputType = 'excel'" nbButtonToggle>اکسل
        </button>
      </nb-button-group>
      <button nbButton (click)="getReportResult()" [nbSpinner]="getResultLoading" [disabled]="getResultLoading"
              style="width: 200px" size="giant" status="primary">شروع
      </button>
    </div>
  </nb-card-footer>
</nb-card>
<nb-card *ngIf="reportOutputType === 'table'">
  <nb-card-header>خروجی گزارش {{ report?.name }}</nb-card-header>
  <nb-card-body>
    <p-table
      [tableStyle]="{'min-width': '80rem'}"
      [value]="reportResult"
      [tableStyleClass]="'table text-center table-striped  stacked-table table-hover'"
      [alwaysShowPaginator]="false"
      [autoLayout]="true"
      [loading]="getResultLoading"
      [paginator]="true"
      [rows]="50"
      [totalRecords]="reportResult.length"
    >
      <ng-template pTemplate="header">
        <tr>
          <th *ngFor="let output of reportOutput">{{ output.label }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-result>
        <tr>
          <ng-container *ngFor="let output of reportOutput">
            <td
              *ngIf="output.type !== 'json' && output.type !== 'api' && output.type !== 'lazyResult'"
              [innerHTML]="(result[output.id] | reportOutput:output) | bypassTrustHtml"></td>
            <td *ngIf="output.type === 'json' && result[output.id] !== null">
              <button size="tiny" (click)="openJsonViewerDialog(result[output.id])" nbButton status="info"><i
                class="fas fa-search"></i></button>
            </td>
            <td *ngIf="output.type === 'json' && result[output.id] === null">-</td>
            <td *ngIf="output.type === 'api' || output.type === 'lazyResult'">
              <button nbButton status="primary"
                      type="button"
                      [nbSpinner]="sendReportApiRequestLoading" [disabled]="sendReportApiRequestLoading"
                      (click)="openReportApiModal(result[output.id],output.type)">{{ output.label }}
              </button>
            </td>
          </ng-container>
        </tr>
      </ng-template>
    </p-table>

  </nb-card-body>
</nb-card>
<nb-card *ngIf="reportOutputType === 'chart'">
  <nb-card-header>خروجی گزارش {{ report?.name }}</nb-card-header>
  <nb-card-body>
    <div class="row">
      <div *ngFor="let chart of reportResult" class="col-12">
        <canvas [id]="chart.id"></canvas>
      </div>
    </div>
  </nb-card-body>
</nb-card>
<ng-template #JSONOutputTemplate>
  <nb-card class="jsonDialog">
    <nb-card-body>
      <div style="direction: ltr;text-align: left" id="json-output-result"></div>
    </nb-card-body>
  </nb-card>
</ng-template>
<ng-template #ExcelResultPasswordTemplate>
  <nb-card>
    <nb-card-header>رمز فایل فشرده</nb-card-header>
    <nb-card-body>
      <p class="mb-2">فایل فشرده در حال آماده‌سازی است. شما می‌توانید فایل را از صفحه اصلی گزارش‌گیری قسمت فایل‌ها
        دانلود کنید.</p>
      <div class="d-flex flex-column gap-3">
        <label>
          لطفا رمز فایل فشرده را در جای امن نگه‌داری کنید این رمز قابل بازیابی نخواهد بود.
        </label>
        <nb-form-field>
          <input dir="ltr" class="code" fullWidth type="text" [value]="excelResultPassword" readonly
                 nbInput>
          <button nbPrefix nbButton ghost (click)="copyPassword()">
            <nb-icon icon="copy"
                     pack="eva">
            </nb-icon>
          </button>
        </nb-form-field>
        <a routerLink="/dashboard/report/queue-list">ورود به صفحه فایل‌ها</a>
      </div>
    </nb-card-body>
  </nb-card>
</ng-template>
<ng-template #ReportApiFormModalTemplate let-ref="dialogRef">
  <nb-card style="min-width: 900px">
    <nb-card-header>{{ selectedReportApi.label }}</nb-card-header>
    <nb-card-body>
      <div class="row">
        <ng-container *ngFor="let filed of selectedReportApi.fields" [ngTemplateOutlet]="InputFilter"
                      [ngTemplateOutletContext]="{filter:filed,selectedReportFilter:reportApiFilter}"></ng-container>
      </div>
    </nb-card-body>
    <nb-card-footer>
      <div class="d-flex gap-3">
        <button nbButton (click)="ref.close()" status="basic">انصراف</button>
        <button nbButton status="primary" [nbSpinner]="sendReportApiRequestLoading"
                [disabled]="sendReportApiRequestLoading" (click)="submitReportApi(ref)">ارسال
        </button>
      </div>
    </nb-card-footer>
  </nb-card>
</ng-template>

<ng-template #InputFilter let-filter="filter" let-selectedReportFilter="selectedReportFilter">
  <div class="col-6" *ngIf="filter.type === 'user'">
    <nb-card status="basic">
      <nb-card-header>
        <div class="d-flex gap-1 align-items-center">
                <span>
                انتخاب کاربر <ng-container *ngIf="!filter.required">(اختیاری)</ng-container>
              </span><strong *ngIf="filter.required" class="text-danger">*</strong>
        </div>
      </nb-card-header>
      <nb-card-body>
        <app-general-report-user-filter [single]="true" (add)="selectedReportFilter[filter.id] = $event[0].id"
                                        (remove)="selectedReportFilter[filter.id] = $event[0]?.id"></app-general-report-user-filter>
      </nb-card-body>
    </nb-card>
  </div>
  <div class="col-3"
       *ngIf="filter.type === 'decimal' || filter.type === 'integer' || filter.type === 'string' || filter.type === 'rtlString' || filter.type === 'ltrString'">
    <nb-card status="basic">
      <nb-card-header>
        <div class="d-flex gap-1 align-items-center">
                <span>{{ filter.label }}
                  <ng-container *ngIf="!filter.required">(اختیاری)</ng-container></span><strong *ngIf="filter.required"
                                                                                                class="text-danger">*</strong>
        </div>
      </nb-card-header>
      <nb-card-body>
        <input
          *ngIf="filter.type !== 'decimal'"
          [dir]="filter.type === 'ltrString' || filter.type === 'integer'  ? 'ltr' : 'rtl'"
          [type]="filter.type === 'integer'? 'number' : 'text'" class="w-100"
          [attr.placeholder]="filter.label" nbInput [(ngModel)]="selectedReportFilter[filter.id]"
          status="basic">
        <input
          *ngIf="filter.type === 'decimal'"
          dir="ltr"
          type="text" class="w-100"
          [attr.placeholder]="filter.label" nbInput [ngModel]="selectedReportFilter[filter.id] | number:'1.0-8'"
          (ngModelChange)="selectedReportFilter[filter.id] = $event"
          appLimitDecimalNumber
          status="basic">
        <app-validation-error [errors]="validationError" [name]="filter.id"></app-validation-error>
      </nb-card-body>
    </nb-card>
  </div>

  <div class="col-3" *ngIf="filter.type === 'market'">
    <nb-card status="basic">
      <nb-card-header>
        <div class="d-flex gap-1 align-items-center">
                <span>{{ filter.label }}
                  <ng-container *ngIf="!filter.required">(اختیاری)</ng-container></span><strong *ngIf="filter.required"
                                                                                                class="text-danger">*</strong>
        </div>
      </nb-card-header>
      <nb-card-body>
        <app-market-selector
          (selectedMarketChange)="selectedReportFilter[filter.id] = $event.id"></app-market-selector>
      </nb-card-body>
    </nb-card>
  </div>
  <div class="col-3" *ngIf="filter.type === 'currency'">
    <nb-card status="basic">
      <nb-card-header>
        <div class="d-flex gap-1 align-items-center">
                <span>{{ filter.label }}
                  <ng-container *ngIf="!filter.required">(اختیاری)</ng-container></span><strong *ngIf="filter.required"
                                                                                                class="text-danger">*</strong>
        </div>
      </nb-card-header>
      <nb-card-body>
        <app-select-currency [required]="filter.required"
                             (currency)="selectedReportFilter[filter.id] = $event[0].id"></app-select-currency>
      </nb-card-body>
    </nb-card>
  </div>
  <div class="col-3" *ngIf="filter.type === 'enum'">
    <nb-card status="basic">
      <nb-card-header>
        <div class="d-flex gap-1 align-items-center">
                <span>{{ filter.label }}
                  <ng-container *ngIf="!filter.required">(اختیاری)</ng-container></span><strong *ngIf="filter.required"
                                                                                                class="text-danger">*</strong>
        </div>
      </nb-card-header>
      <nb-card-body>
        <nb-select fullWidth [(ngModel)]="selectedReportFilter[filter.id]">
          <nb-option *ngIf="!filter.required" [value]="null">انتخاب همه</nb-option>
          <nb-option *ngFor="let param of filter.extraParams" [value]="param.id">{{ param.label }}</nb-option>
        </nb-select>
      </nb-card-body>
    </nb-card>
  </div>
  <div class="col-12" *ngIf="filter.type === 'rangeDateTime' || filter.type === 'rangeDate'">
    <nb-card status="basic">
      <nb-card-header>
        <div class="d-flex gap-1 align-items-center">
                <span>{{ filter.label }}
                  <ng-container *ngIf="!filter.required">(اختیاری)</ng-container></span>
          <strong *ngIf="filter.required" class="text-danger">*</strong>
        </div>
      </nb-card-header>
      <nb-card-body>
        <app-datetime-range-picker [type]="filter.type" [required]="filter.required"
                                   (selectedRangeDate)="selectedReportFilter[filter.id] = $event"></app-datetime-range-picker>
      </nb-card-body>
    </nb-card>
  </div>
</ng-template>
